<template>
  <div class="pdf-wrap" :class="{'fixed-top-toolbar':toolbarType===1}">
    <div class="toolbar">
      <div class="page-group">
        <div class="page-btn" title="上一页" :class="{disable:index<=0}" @click="handlePrev">上一页</div>
        <div class="page-counter">
          {{ index + 1 }} / {{ pages }}
        </div>
        <div class="page-btn" title="下一页" :class="{disable:index>=pages-1}" @click="handleNext">下一页</div>
      </div>
      <div class="toolbar-split" />
      <div class="zoom-group">
        <i class="el-icon-zoom-in zoom-btn" title="放大" :class="{disable:zoom>=500}" @click="handleEnlargement" />
        <div class="scale-val">{{ zoom }}%</div>
        <i class="el-icon-zoom-out zoom-btn" title="缩小" :class="{disable:zoom<=30}" @click="handleNarrow" />
      </div>
    </div>
    <div ref="scrollWrap" class="scroll-wrap">
      <div v-for="(item, i) in data" :key="i" class="pdf-page" :style="'height:'+zoom+'%'">
        <img :src="item.url" crossorigin="anonymous" class="pdf-img" alt>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from '@/utils/index.js'
export default {
  props: {
    toolbarType: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: undefined
    },
    externalZoom: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      index: 0,
      zoom: 100,
      pages: this.data.length,
      $_scrollHandler: null
    }
  },
  watch: {
    data(val) {
      this.pages = val.length
    },
    externalZoom(val) {
      this.zoom = val
    }
  },
  mounted() {
    const _this = this
    this.$_scrollHandler = debounce(function() {
      const wrapHeight = _this.$refs.scrollWrap.getElementsByClassName('pdf-page')[0].offsetHeight
      const scrollTop = this.scrollTop
      const pageIndex = Math.round(scrollTop / wrapHeight)
      _this.index = pageIndex
      _this.$emit('changeIndex', pageIndex)
    }, 200)
    this.initScrollEvent()
  },
  beforeDestroy() {
    this.destroyScrollEvent()
  },
  methods: {
    initScrollEvent() {
      this.$refs.scrollWrap.addEventListener('scroll', this.$_scrollHandler)
    },
    destroyScrollEvent() {
      this.$refs.scrollWrap.removeEventListener('scroll', this.$_scrollHandler)
    },
    goPage(index) {
      this.index = index
      const wrapHeight = this.$refs.scrollWrap.offsetHeight
      this.$refs.scrollWrap.scrollTop = wrapHeight * index
    },
    handlePrev() {
      // 上一页
      const wrapHeight = this.$refs.scrollWrap.offsetHeight
      let scrollTop = this.$refs.scrollWrap.scrollTop - wrapHeight
      scrollTop = scrollTop < 0 ? 0 : scrollTop
      const pageIndex = Math.ceil(scrollTop / wrapHeight)
      this.index = pageIndex
      this.$refs.scrollWrap.scrollTop = scrollTop
      this.$emit('changeIndex', this.index)
    },
    handleNext() {
      // 下一页
      const wrapHeight = this.$refs.scrollWrap.offsetHeight
      const scrollTop = this.$refs.scrollWrap.scrollTop + wrapHeight
      const pageIndex = parseInt(scrollTop / wrapHeight)
      this.index = pageIndex > this.pages - 1 ? this.pages - 1 : pageIndex
      this.$refs.scrollWrap.scrollTop = scrollTop
      this.$emit('changeIndex', this.index)
    },
    handleEnlargement() {
      let zoom = this.zoom + 10
      zoom = zoom > 500 ? 500 : zoom
      this.zoom = zoom
      this.$emit('zoomChange', zoom)
    },
    handleNarrow() {
      let zoom = this.zoom - 10
      zoom = zoom < 30 ? 30 : zoom
      this.zoom = zoom
      this.$emit('zoomChange', zoom)
    }
  }
}
</script>

<style scoped>
.pdf-wrap {
  position: absolute;
  top: 0;
  right: 200px;
  left: 0;
  height: 100%;
  user-select: none;
}

.pdf-wrap.fixed-top-toolbar .toolbar {
  position: fixed;
  left: 30%;
  right: 30%;
  z-index: 999;
  height: 50px;
  line-height: 50px;
  top: 0;
  background: transparent;
}

.pdf-wrap.fixed-top-toolbar .scroll-wrap {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #404040;
}

.pdf-wrap .toolbar {
  position: relative;
  left: 0;
  right: 0;
  z-index: 999;
  cursor: default;
  height: 32px;
  line-height: 32px;
  background-color: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pdf-wrap .toolbar .toolbar-split {
  padding: 8px 0;
  width: 1px;
  background-color: #f0f0fe;
  z-index: 99;
  display: inline-block;
  margin: 5px;
  vertical-align: middle;
}

.pdf-wrap .toolbar .page-group {
  height: 100%;
  padding-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.pdf-wrap .toolbar .page-group .page-counter {
  margin: 0 5px;
  min-width: 50px;
  text-align: center;
}

.pdf-wrap .toolbar .page-group .page-btn {
  font-size: 12px;
  line-height: 22px;
  height: 22px;
  padding: 0 8px;
  cursor: pointer;
  margin: 0;
  border-radius: 4px;
  background: #5d5959;
  border: 1px solid #f9f9f9;
}

.pdf-wrap .toolbar .page-group .page-btn:hover {
  background-color: #444141;
}

.pdf-wrap .toolbar .page-group .page-btn.disable {
  color: #bbb;
  cursor: not-allowed;
  background: #656363;
  border-color: #bbb;
}

.pdf-wrap .toolbar .page-group .page-btn.disable:hover {
  background-color: #656363;
}

.pdf-wrap .toolbar .zoom-group {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}

.pdf-wrap .toolbar .zoom-group .scale-val {
  min-width: 50px;
  text-align: center;
  margin: 0 5px;
}

.pdf-wrap .toolbar .zoom-group .zoom-btn {
  font-size: 12px;
  cursor: pointer;
  margin: 0;
}

.pdf-wrap .toolbar .zoom-group .zoom-btn.disable {
  color: #bbb;
  cursor: not-allowed;
}

.pdf-wrap .scroll-wrap {
  width: 100%;
  height: calc(100% - 32px);
  overflow: auto;
  background: #404040;
}

.pdf-wrap .pdf-page {
  width: 100%;
  height: 100%;
  padding: 10px 0;
}

.pdf-wrap .pdf-page .pdf-img {
  height: 100%;
  background-color: #fff;
}

.pdf-wrap .file-nav {
  z-index: 1;
  width: 100px;
  cursor: pointer;
}

.pdf-wrap .file-nav .nav-wrapper {
  color: #fff;
  font-size: 24px;
  border-radius: 35px;
  width: 70px;
  height: 70px;
  text-align: center;
  line-height: 70px;
  background-color: rgba(0, 0, 0, .5);
  margin: auto;
  transition: background 218ms ease;
}

.pdf-wrap .file-nav.next {
  position: absolute;
  top: 60px;
  right: 0;
  bottom: 0;
}

.pdf-wrap .file-nav.next .nav-wrapper {
  position: absolute;
  top: 0;
  right: 25px;
  bottom: 0;
}

.pdf-wrap .file-nav.prev {
  position: absolute;
  top: 60px;
  left: 0;
  bottom: 0;
}

.pdf-wrap .file-nav.prev .nav-wrapper {
  position: absolute;
  top: 0;
  left: 25px;
  bottom: 0;
}
</style>
